import React from 'react';
import { renderHero } from './shared/renderers';

/**
 * HeroBlock — rendu PARTAGÉ avec l'éditeur intranet (shared/renderers).
 * Voile sombre (overlayOpacity), alignement et couleur de texte respectés.
 */
export default function HeroBlock({ props = {}, theme }) {
  return renderHero(props, theme);
}
